FD.CONTROL = (function ($, me) {
    'use strict';

    var child = me.CONTROL || {};

    /* ========================================================================
     *  private vars
     * ========================================================================
    */
    var ELEM = '[data-fd=timepicker]';
    var defaults = {
        useparent: true
    };
    var ignoreEvent = false;

    function setTimePicker(container) {
        $(ELEM, container).each(function (i, e) {
            var elem = $(e);
            var options = $.extend({}, defaults, elem.data());
            me.setControlItemOptions(elem, options);
            elem.data({ initial: elem.val() });
        });

        $(ELEM, container).timepicker({
            timeFormat: 'h:mm p',
            dropdown: false,
            change: function (time) {
                if (ignoreEvent) {
                    ignoreEvent = false;
                    return;
                }
                var timepicker = this.timepicker();
                if (time) {
                    this.data({ value: time, initial: timepicker.format(time) });
                    var data = this.data();
                    me.setCallBackFromData(this, { e: this, value: data.value, initial: data.initial, tag: data.tag, parentid: data.parentid, length: data.length || 0 });
                } else {
                    // Prevent callback on reset.
                    ignoreEvent = true;
                    timepicker.setTime(this.data("initial"));
                    if (this.data("initial") == "") {
                        this.val("");
                    }
                    ignoreEvent = false;
                }
            }
        });
    }

    /* ========================================================================
     *  public methods
     * ========================================================================
    */


    child.setTimePicker = function (container) {
        setTimePicker(container);
    };

    return child;
}(jQuery, FD));